import keyMirror from 'keymirror-nested'

export default keyMirror({
  ACCOUNTING_LIST: {
    FETCH: {
      REQUEST: null,
      SUCCEEDED: null,
      FAILED: null,
    },
    CLEAN: {
      ERRORS: null,
      STATE: null,
    },
  },
})
